import { render, staticRenderFns } from "./all.vue?vue&type=template&id=0b02540a"
import script from "./all.vue?vue&type=script&lang=js"
export * from "./all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LocationsAllContainer: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/locations/all/Container.vue').default,LocationsAllContainer: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/locations/all/Container.vue').default})
